export var EventType;
(function (EventType) {
    EventType["INTERMEDIARY_CONTAINED"] = "INTERMEDIARY_CONTAINED";
    EventType["INTERMEDIARY_LEAD"] = "INTERMEDIARY_LEAD";
    EventType["INTERMEDIARY_REDIRECTION"] = "INTERMEDIARY_REDIRECTION";
    EventType["INTERMEDIARY_VIEWED"] = "INTERMEDIARY_VIEWED";
})(EventType || (EventType = {}));
export var EventSubtype;
(function (EventSubtype) {
    EventSubtype["INTERMEDIARY_ADIMSXL_CONTAINED"] = "INTERMEDIARY_ADIMSXL_CONTAINED";
    EventSubtype["INTERMEDIARY_ADIMSXL_CTA_REDIRECTTOIPP"] = "INTERMEDIARY_ADIMSXL_CTA_REDIRECTTOIPP";
    EventSubtype["INTERMEDIARY_ADIMSXL_VIEWED"] = "INTERMEDIARY_ADIMSXL_VIEWED";
    EventSubtype["INTERMEDIARY_CARD_CONTAINED"] = "INTERMEDIARY_CARD_CONTAINED";
    EventSubtype["INTERMEDIARY_CARD_FILTER_CONTAINED"] = "INTERMEDIARY_CARD_FILTER_CONTAINED";
    EventSubtype["INTERMEDIARY_CARD_VIEWED"] = "INTERMEDIARY_CARD_VIEWED";
    EventSubtype["INTERMEDIARY_DETAIL_VIEWED"] = "INTERMEDIARY_DETAIL_VIEWED";
    EventSubtype["INTERMEDIARY_SPOTLIGHT_CONTAINED"] = "INTERMEDIARY_SPOTLIGHT_CONTAINED";
    EventSubtype["INTERMEDIARY_SPOTLIGHT_CTA_REDIRECTTOIPP"] = "INTERMEDIARY_SPOTLIGHT_CTA_REDIRECTTOIPP";
    EventSubtype["INTERMEDIARY_SPOTLIGHT_LOGO_REDIRECTTOIPP"] = "INTERMEDIARY_SPOTLIGHT_LOGO_REDIRECTTOIPP";
    EventSubtype["INTERMEDIARY_SPOTLIGHT_REVIEWS_REDIRECTTOIPP"] = "INTERMEDIARY_SPOTLIGHT_REVIEWS_REDIRECTTOIPP";
    EventSubtype["INTERMEDIARY_SPOTLIGHT_VIEWED"] = "INTERMEDIARY_SPOTLIGHT_VIEWED";
    EventSubtype["INTERMEDIARY_WLAC_CONTAINED"] = "INTERMEDIARY_WLAC_CONTAINED";
    EventSubtype["INTERMEDIARY_WLAC_CTA_REDIRECTTOIPP"] = "INTERMEDIARY_WLAC_CTA_REDIRECTTOIPP";
    EventSubtype["LEAD_CHAT_ANSWERED"] = "LEAD_CHAT_ANSWERED";
    EventSubtype["LEAD_CHAT_SENT"] = "LEAD_CHAT_SENT";
    EventSubtype["LEAD_EMAIL_SENT"] = "LEAD_EMAIL_SENT";
    EventSubtype["LEAD_FORM_SUBMITTED"] = "LEAD_FORM_SUBMITTED";
    EventSubtype["LEAD_NOTIFICATION_SENT"] = "LEAD_NOTIFICATION_SENT";
    EventSubtype["LEAD_PHONE_UNHIDE_NUMBER"] = "LEAD_PHONE_UNHIDE_NUMBER";
    EventSubtype["LEAD_SENT"] = "LEAD_SENT";
    EventSubtype["LEAD_WEBHOOK_SENT"] = "LEAD_WEBHOOK_SENT";
})(EventSubtype || (EventSubtype = {}));
export var EventPlace;
(function (EventPlace) {
    EventPlace["ESTIMATION_FUNNEL"] = "ESTIMATION_FUNNEL";
    EventPlace["HOME_PAGE"] = "HOME_PAGE";
    EventPlace["PRICE_MAP"] = "PRICE_MAP";
    EventPlace["PRICE_PAGES"] = "PRICE_PAGES";
    EventPlace["SERP_MAP"] = "SERP_MAP";
})(EventPlace || (EventPlace = {}));
export var EventProduct;
(function (EventProduct) {
    EventProduct["INTERMEDIARY_ADIMSXL"] = "INTERMEDIARY_ADIMSXL";
    EventProduct["INTERMEDIARY_CARD"] = "INTERMEDIARY_CARD";
    EventProduct["INTERMEDIARY_SPOTLIGHT"] = "INTERMEDIARY_SPOTLIGHT";
})(EventProduct || (EventProduct = {}));
export var EventChannel;
(function (EventChannel) {
    EventChannel["WEB_DESKTOP"] = "web_desktop";
    EventChannel["WEB_MOBILE"] = "web_mobile";
})(EventChannel || (EventChannel = {}));
export var EventPortal;
(function (EventPortal) {
    EventPortal["IMN"] = "IMN-DEU";
    EventPortal["IWB"] = "IWB-BEL";
    EventPortal["IWT"] = "IWT-DEU";
    EventPortal["LI"] = "LIM-FRA";
    EventPortal["MA"] = "MAG-FRA";
    EventPortal["SL"] = "SLG-FRA";
})(EventPortal || (EventPortal = {}));
export const INTERMEDIARY_ANALYTICS_MODEL_VERSION = '1.0';
export const INTERMEDIARY_ANALYTICS_MODEL_SOURCE = 'AGNA';
